export type FieldType =
  | "text"
  | "textarea"
  | "number"
  | "select"
  | "switch"
  | "image"
  | "tags"
  | "icon"
  | "date";

export interface FieldOption {
  value: string;
  label: string;
}

export interface FieldConfig {
  name: string;
  label: string;
  type: FieldType;
  placeholder?: string;
  options?: FieldOption[];
  required?: boolean;
  help?: string;
  full?: boolean;
  folder?: string;
}

export interface ColumnConfig {
  name: string;
  label: string;
  type?: "text" | "image" | "switch" | "muted";
  className?: string;
}

export type AdminRow = Record<string, unknown> & { id: string };

export function defaultValueFor(type: FieldType): unknown {
  switch (type) {
    case "switch":
      return false;
    case "number":
      return 0;
    case "tags":
      return [];
    case "date":
      return null;
    default:
      return "";
  }
}